import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../../components/SEO/SEO";
import PublicHeader from "../../../components/PublicHeader/PublicHeader";
import PublicFooter from "../../../components/PublicFooter/PublicFooter";

import IconGrid from "../../../components/public-info/sections/IconGrid";
import AnimatedStepFlow from "../../../components/public-info/sections/AnimatedStepFlow";
import ValueSummary from "../../../components/public-info/sections/ValueSummary";
import FAQSection from "../../../components/public-info/sections/FAQSection";

import {
  howItWorksHero,
  howItWorksNeedsGrid,
  howItWorksFamilyDoctorFlow,
  howItWorksValueSummary,
  howItWorksFAQ,
  howItWorksCtas,
} from "./HowItWorksContent";

import "./HowItWorksPage.css";

function iconNode(src: string, alt = ""): React.ReactNode {
  return (
    <img
      src={src}
      alt={alt}
      style={{ width: 22, height: 22, display: "block" }}
    />
  );
}

export default function HowItWorksPage() {
  return (
    <div className="ocf-hiw">
      <SEO
        title="How It Works"
        description="Learn how AcceptingMD helps Ontario patients find family doctors accepting new patients, submit a standardized intake request, and receive updates from participating clinics."
      />
      <PublicHeader variant="solid" />

      {/* Hero - matches Find Family Doctor style */}
      <header className="ocf-hiw-hero">
        <div className="ocf-hiw-hero-inner">
          <div className="ocf-hiw-hero-badge">{howItWorksHero.eyebrow}</div>
          <h1>{howItWorksHero.title}</h1>
          <p className="ocf-hiw-hero-text">{howItWorksHero.subtitle}</p>
        </div>
      </header>

      <main className="ocf-hiw-main">
        <div className="ocf-hiw-sections">
          <IconGrid
            id={howItWorksNeedsGrid.id}
            title={howItWorksNeedsGrid.title}
            subtitle={howItWorksNeedsGrid.subtitle}
            columns={howItWorksNeedsGrid.columns}
            items={howItWorksNeedsGrid.items.map((it) => ({
              ...it,
              icon: iconNode((it as any).iconSrc),
            }))}
          />

          <AnimatedStepFlow
            id={howItWorksFamilyDoctorFlow.id}
            title={howItWorksFamilyDoctorFlow.title}
            subtitle={howItWorksFamilyDoctorFlow.subtitle}
            steps={howItWorksFamilyDoctorFlow.steps.map((s) => ({
              ...s,
              icon: iconNode((s as any).iconSrc),
            }))}
          />

          <ValueSummary
            id={howItWorksValueSummary.id}
            title={howItWorksValueSummary.title}
            bullets={howItWorksValueSummary.bullets}
          />

          <FAQSection
            id={howItWorksFAQ.id}
            title={howItWorksFAQ.title}
            items={howItWorksFAQ.items}
          />
        </div>
      </main>

      {/* CTA - matches home page final CTA style */}
      <section className="ocf-hiw-cta">
        <div className="ocf-hiw-cta-inner">
          <h2>{howItWorksCtas.title}</h2>
          <p>{howItWorksCtas.subtitle}</p>
          <div className="ocf-hiw-cta-buttons">
            {howItWorksCtas.buttons.map((btn, idx) => (
              <Link
                key={idx}
                to={btn.to}
                className={`ocf-hiw-cta-btn ocf-hiw-cta-btn--${btn.variant}`}
              >
                {btn.label}
              </Link>
            ))}
          </div>
        </div>
      </section>

      <PublicFooter />
    </div>
  );
}
